import { KYMW1407Model } from '../kymw1407.model';
import { GetUseRecordImageListModel } from '../../kymw1400/vo/get-use-record-image-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用履歴画像リストを取得する。
 *
 * @export
 * @class GetUseRecordImageListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetUseRecordImageListService extends PlessJsonResponderSub<any> {

  private model: KYMW1407Model = null;
  private vo: GetUseRecordImageListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUseRecordImageListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        Pcode: this.vo.pcode,
        ThisOrderCode: this.vo.thisOrderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {GetUseRecordImageListModel} vo
   * @memberof GetUseRecordImageListService
   */
  execute(model: KYMW1407Model, vo: GetUseRecordImageListModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14getUseRecordImageList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUseRecordImageListService
   */
  success(data: any) {
    this.model.updateUseHistoryImageList(data);
  }
}
